import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "theme"];
var _templateObject;
var StyledTableHeader = styled('thead')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.gray;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
    header = _ref2$theme.table.header,
    palette = _ref2$theme.palette,
    fixHeaders = _ref2.fixHeaders;
  return "\n    th {\n      ".concat(fixHeaders ? "position: sticky;\n            top: 0;\n            background: #F5F5F5\n            z-index: 999;" : '', "\n\n      ").concat(fixHeaders && header ? "box-shadow: 0 0 0 ".concat(header.borderWidth, " ").concat(header.borderColor && palette[header.borderColor], ";") : '', "\n\n      ").concat(header ? "border-style: ".concat(header.borderStyle, ";\n            border-width: ").concat(header.borderWidth, ";\n            border-color: ").concat(header.borderColor && palette[header.borderColor], ";\n            color: ").concat(header.color && palette[header.color], ";\n            background-color: ").concat(header.backgroundColor && palette[header.backgroundColor], ";\n            font-weight: ").concat(header.fontWeight, ";\n            text-transform: ").concat(header.textTransform, ";") : '', "\n    }\n").concat(header !== null && header !== void 0 && header.subHeaderBackgroundColor ? "tr:not(:first-of-type) th {\n          background-color: ".concat(palette[header.subHeaderBackgroundColor], ";\n      }") : '', "\n    ");
});
var TableHeader = function TableHeader(_ref3) {
  var children = _ref3.children,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  var ariaLabel = rest.fixHeaders ? {
    'aria-hidden': true
  } : {};
  return /*#__PURE__*/React.createElement(StyledTableHeader, _extends({}, rest, ariaLabel, {
    "data-testid": 'table-header',
    className: className,
    style: style,
    theme: theme
  }), children);
};
var _TableHeader = withDefaultTheme(/*#__PURE__*/memo(TableHeader));

export default _TableHeader;
